import { render } from "./NoticeModal_hp.vue?vue&type=template&id=1db6fbd1&scoped=true"
import script from "./NoticeModal_hp.vue?vue&type=script&lang=js"
export * from "./NoticeModal_hp.vue?vue&type=script&lang=js"

import "./NoticeModal_hp.vue?vue&type=style&index=0&id=1db6fbd1&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db6fbd1"]])

export default __exports__